<template>
  <div class="pages">
    <div class="top facab">
      <div class="t-l">{{ $t('main.ShippingInformation') }}</div>
      <div class="t-r fac">
        <div class="t-r-l fac">
          <div style="padding: 0 1.875rem;color: #fff;font-weight: bold">
            {{ $t('main.AddressInformation') }}
          </div>
          <img src="/static/product/icn_right_w.png" class="tImg" />
          <div style="padding: 0 1.875rem;color: #fff;font-weight: bold">
            {{ $t('main.ShippingInformation') }}
          </div>
        </div>
        <img src="/static/product/icn_right.png" class="tImg" />
        <div class="t-r-e">{{ $t('main.ReviewPayment') }}</div>
      </div>
    </div>
    <div class="content">
      <el-row>
        <el-col :span="16" style="padding-right:1.5rem;">
          <div class="c-th facab">
            <div class="cPointer color-e31409">{{ $t("main.ShippingInformation") }}</div>
          </div>
          <div class="addr-list">
            <div class="send-to">
              {{ $t('main.sendTo') }}：
              <span>{{ addressInfo.receive_user }}</span>
              <span v-if="isCN">,{{ addressInfo.receive_address }}</span>
              <span v-if="!isCN">,{{ addressInfo.receive_address }}</span>
              <span v-if="!isCN && addressInfo.receive_address_2">,{{ addressInfo.receive_address_2 }}</span>
              <span v-if="!isCN && addressInfo.receive_address_3">,{{ addressInfo.receive_address_3 }}</span>
            </div>
            <el-radio v-if="isCN" v-model="freightPrice" :label="freightPrice">
              <span style="font-weight: bold;color: rgb(51, 51, 51);padding-right: 1.5rem;">
                {{ $t('main.freight') }}
                <span v-if="isCN && freightPrice == 0">
                  (包邮)
                </span>
                :{{ $t('main.monetaryUnit') }} {{ freightPrice }}
              </span>
            </el-radio>

            <el-radio v-if="!isCN" v-model="freightIdChooise" @change="getFreightPrice" label="1">
              <span style="font-weight: bold;color: rgb(51, 51, 51);padding-right: 1.5rem;"> Let Union Optic pick the most appropriate shipping carrier to deliver your order;</span>
              <span style="color: rgb(153, 153, 153);"> <br />Freight Cost: $80 (Shipping rate could not be resolved. We will contact you with a shipping quote.)</span>
            </el-radio>

            <el-radio v-if="!isCN" v-model="freightIdChooise" @change="getFreightPrice" label="2">
              <span style="font-weight: bold;color: rgb(51, 51, 51);padding-right: 1.5rem;"> I have a freight collect account and prefer to choose my carrier.</span>
            </el-radio>
            <div v-if="!isCN && freightIdChooise == 2" class="carrier">
              <el-form ref="form" :model="carrierData" label-width="180px">
                <template>
                  <el-form-item label="Carrier">
                    <el-select
                        v-model="carrierData.carrier"
                        size="small"
                        placeholder="Select Carrier"
                        filterable
                        @change="carrierMethodChange($event)"
                    >
                      <el-option
                          v-for="(item, index) in carrierMethod"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                      >
                        <span> {{ item.name }} </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Account No.">
                    <el-input
                        v-model="carrierData.carrier_account"
                        style="width: 40%"
                        :placeholder="$t('main.pleaseEnter')"
                        @input="carrierMethodChange($event)"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-form>
            </div>
          </div>

          <div class="c-th">
            <div>{{ $t("main.Invoice") }}</div>
          </div>
          <div class="c-table">
            <div class="product" style="color: rgb(153, 153, 153);">
              <div>
                <div>
                  <div class="td-label">
                    <div>
                      <div v-if="billingInfo.company_type==1">
                        <div v-if="billingInfo.receive_user!=''">{{ $t('main.receiver') }}：{{ billingInfo.receive_user }}</div>
                        <div v-if="billingInfo.receive_phone!=''">{{ $t('main.telephone') }}：{{ billingInfo.receive_phone }}</div>
                        <div v-if="billingInfo.receive_email!=''">{{ $t('main.receiveEmail') }}：{{ billingInfo.receive_email }}</div>
                        <div v-if="billingInfo.name!=''">{{ $t('main.Company') }}：{{ billingInfo.name }}</div>
                        <div v-if="billingInfo.number!=''">{{ $t('main.TaxpayerIdentificationNumber') }}：{{ billingInfo.number }}</div>
                        <div v-if="billingInfo.address!='' && isCN">{{ $t('main.CompanyAddress') }}：{{ billingInfo.address }}</div>
                        <div v-if="billingInfo.address!='' && !isCN">{{ $t('main.AddressLine1') }}：{{ billingInfo.address }}</div>
                        <div v-if="billingInfo.address_2!='' && !isCN">{{ $t('main.AddressLine2') }}：{{ billingInfo.address_2 }}</div>
                        <div v-if="billingInfo.address_3!='' && !isCN">{{ $t('main.AddressLine3') }}：{{ billingInfo.address_3 }}</div>
                        <div v-if="billingInfo.phone!=''">{{ $t('main.CompanyPhone') }}：{{ billingInfo.phone }}</div>
                        <div v-if="billingInfo.bank_name!=''">{{ $t('main.BankName') }}：{{ billingInfo.bank_name }}</div>
                        <div v-if="billingInfo.bank_number!='0'&&billingInfo.bank_number!=''">{{ $t('main.BankAccount') }}：{{ billingInfo.bank_number }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="c-th" v-if="note_message">
            <div>{{ $t("main.remark") }}</div>
          </div>
          <div class="c-table" v-if="note_message">
            <div class="product" style="color: rgb(153, 153, 153);">
              <div>
                <div>
                  <div class="td-label">
                    <div>
                      <div class="fac lh30">
                        <div> {{ note_message }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="t-bottom facab">
            <div>
              <span v-if="totalNumber" style="margin-left: 2.5rem" v-html="$t('main.chooseShopNum', { num: totalNumber })"></span>
            </div>
            <div>
              <span style="margin-left: 2.5rem">{{ $t('main.freight') }} ：{{ $t('main.monetaryUnit') }} {{ freightPrice }}</span>
            </div>
            <div>
              <span v-if="totalPrice" style="margin-right: 2.5rem">
                {{ $t('main.totalPrice') }}：{{ $t('main.monetaryUnit') }}
                <span class="color-635796">{{ totalPrice }}</span>
              </span>
              <el-button class="mainBtm" :loading="loading" @click="goToPayment()">
                {{ $t("main.commit") }}
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="c-th">
            <div>{{ $t("main.OrderingInformation") }}</div>
          </div>
          <div class="c-table">
            <div
                class="product"
                v-for="(item, index) in shoplist"
                :key="index"
                v-if="Math.floor(index/3) <= shopListFloor"
                style="color: rgb(153, 153, 153);"
            >
              <div>
                <div style="text-align: center;">
                  <img style="cursor: pointer;" @click="gotoProductDetail(item)" :src="item.productimg" class="tr-img" />
                  <div class="td-label">
                    <div class="fac lh30" style="color: #333333;">
                      <div v-if="item.type_name" style="width: 10rem;">{{ $t('main.product') }}</div>
                      <div v-if="item.type_name" style="width: calc(100% - 10rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item)">{{item.type_name}}</div>
                    </div>
                    <div class="fac lh30" style="color: #333333;">
                      <div v-if="item.product_model" style="width: 10rem;">{{ $t('main.partNumber') }}</div>
                      <div v-if="item.product_model" style="width: calc(100% - 10rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item)">{{item.product_model}}</div>
                    </div>
                    <div class="fac lh30" style="color: #333333;">
                      <div style="width: 10rem;">{{ $t('main.totalNum') }}</div>
                      <div style="width: calc(100% - 10rem);">{{ item.number }}</div>
                    </div>
                    <div class="fac lh30" style="color: #333333;">
                      <div style="width: 10rem;">{{ $t('main.priceForOne') }}</div>
                      <div style="width: calc(100% - 10rem);">{{ item.price ? $t('main.monetaryUnit') + item.price : '/' }}</div>
                    </div>
                    <div>
                      <div class="fac" style="color: #333333;">{{ $t('main.ProductSpecifications') }}</div>
                      <div
                          class="fac lh30"
                          v-for="(itemd, index) in item.product_info"
                          v-if="itemd.isShow"
                          :key="index"
                      >
                        <div style="width: 10rem;padding-left: 1.5rem;">{{ itemd.title }}</div>
                        <div style="width: calc(100% - 10rem);">{{ itemd.value }}</div>
                      </div>
                      <div
                          class="fac lh30"
                          v-for="(itemd, index) in item.product_info"
                          v-if="!item.product_model || (!itemd.isShow && showMore.findIndex(res=>{return res == item.id;}) > -1)"
                          :key="index"
                      >
                        <div style="width: 10rem;padding-left: 1.5rem;">{{ itemd.title }}</div>
                        <div style="width: calc(100% - 10rem);">{{ itemd.value }}</div>
                      </div>
                      <div v-if="item.product_model" class="fac color-635796" style="cursor: pointer;padding-left: 1.5rem;" @click="handleProductParamsMore(item)">
                        {{ showMore.findIndex(res=>{return res == item.id;}) > -1 ? $t('main.Cut') : $t('main.More') }}
                        <i :class="showMore.findIndex(res=>{return res == item.id;}) > -1 ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t-bottom" v-if="!shopListFloorComplete">
            <div @click="handleOrderProductMore()" style="text-align: center;cursor: pointer;">
              {{ $t('main.More') }}
              <i class="el-icon-arrow-down"></i>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {readAddress, readBill, getProductInfo} from "@/api/index"; //获取当前用户的地址列表
import { Shopcarlist } from "@/api/shopcar"; //获取购物车数据
import { editMember,getUserInfo} from "@/api/index";
import Cookies from "js-cookie";
import countryList from "@/api/country.json";
import {placeOrder} from "@/api/order";

export default {
  watch: {
    "$store.state.siteInfo": function(newV, oldV) {
      this.isCN = this.$i18n.locale === "zn";
      const totalPrice = window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).totalPrice : 0;
      if (this.isCN) {
        this.freightPrice = totalPrice >= 1000 ? 0 : 20;
      } else {
        this.freightPrice = 80;
      }
      this.totalPrice = Math.round( (totalPrice + this.freightPrice) * 100)/100;
      if (newV && typeof oldV != 'object') {
        this.$router.push({ path: "/shoppingCart"});
      }
    }
  },
  created() {
    this.isCN = this.$i18n.locale === "zn";
    this.init();
    const totalPrice = window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).totalPrice : 0;
    if (this.isCN) {
      this.freightPrice = totalPrice >= 1000 ? 0 : 20;
    } else {
      this.freightPrice = 80;
    }
    this.totalPrice = Math.round( (totalPrice + this.freightPrice) * 100)/100;
    this.carrierData.carrier = parseInt(JSON.parse(Cookies.get("userinfo")).carrier);
    this.carrierData.carrier_account = JSON.parse(Cookies.get("userinfo")).carrier_account;

  },
  data() {
    return {
      isCN: true, // 判断当前是中文还是英文
      freightPrice: 0,
      freightIdChooise: "1",  // 选中的物流账号
      addressId: window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).address_id : 0,
      addressInfo: {},
      carrierData: {},
      carrierMethod: [
        {
          value: 1,
          name: 'UPS',
        },
        {
          value: 2,
          name: 'Fedex',
        },
        {
          value: 3,
          name: 'DHL',
        },
      ],

      billingId: window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).billing_id : 0,
      billingInfo: {},

      // 遮罩层
      loading: false,
      shoplist: [], //所有购物车的信息
      shopListFloor: 0, // 订单产品数据限制每次加载3个
      shopListFloorComplete: true, // 已经加载完成
      note_message: window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).note_message : '',
      totalPrice: window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).totalPrice : 0,
      totalNumber: window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).totalNumber : 0,
      showMore: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  methods: {
    init() {
      this.getAddressInfo(); //查询收货地址信息
      this.getBillingInfo(); //查询发票地址信息
      let info = window.sessionStorage.getItem("settlementInfo");
      //查询购物车的信息根据id 显示
      if(info) {
        if(JSON.parse(info).resource) {
          let item = JSON.parse(info);
          this.shoplist.push(item);
        } else {
          this.getCarList();
        }
      }
    },
    //获得地址信息
    getAddressInfo() {
      this.addressInfo = {};
      let params = {
        req: {
          id: this.addressId,
        }
      };
      readAddress(params).then((res) => {
        if (res.rsp.code === 0) {
          this.addressInfo = res.data;
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    //获得发票信息
    getBillingInfo() {
      this.billingInfo = {};
      let params = {
        req: {
          id: this.billingId,
        }
      };
      readBill(params).then((res) => {
        if (res.rsp.code === 0) {
          this.billingInfo = res.data;
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    carrierMethodChange(e) {
      this.$forceUpdate();
    },
    getFreightPrice() {
      const totalPrice = window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).totalPrice : 0;
      this.freightPrice = this.freightIdChooise == 1 ? 80:0;
      this.totalPrice = Math.round( (totalPrice + this.freightPrice) * 100)/100;
    },
    //获取当前有用户所有购物车的信息
    getCarList() {
      var params = {
        req: {
          page: 1,
          limit: 1000,
          where: [
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            }
          ]
        }
      };
      Shopcarlist(params).then((res) => {
        const productType = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
        for (var i = 0; i < res.data.list.length; i++) {
          for (var j = 0; j < JSON.parse(window.sessionStorage.getItem('settlementInfo')).product_id_numbers.length; j++) {
            if (
                res.data.list[i].product_id ==
                JSON.parse(window.sessionStorage.getItem("settlementInfo")).product_id_numbers[j].product_id
            ) {
              const nowProductType = productType.find(productType => {
                return productType.id == res.data.list[i].product_info.type_id;
              });
              const singleData = {
                uuid: res.data.list[i].uuid,
                user_id: res.data.list[i].user_id,
                type_id: res.data.list[i].product_info.type_id,
                type_name: nowProductType.name,
                product_id: res.data.list[i].product_id,
                product_model: res.data.list[i].product_info.product_model,
                product_info: res.data.list[i].product_info.product_data,
                price: res.data.list[i].price,
                number: res.data.list[i].number,
                site_id: "",
                productimg: res.data.list[i].product_info.thumb,
                kucun: res.data.list[i].product_info.stock,
                id: Date.now().toString(36) + i,
                checked: false // 购物车是否选中
                //缺少字段：1，产品图片
              };
              this.shoplist.push(singleData);
            }
          }
        }

        this.shopListFloorComplete = this.shoplist.length <= 3;
      });
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    // 组装数据提交订单请求
    goToPayment() {
      this.loading = true;

      let promise1 = true;
      let promise2 = true;
      if (this.freightIdChooise == 2) {
        // 物流承运商数据是否完善
        if (!this.carrierData.carrier) {
          this.$message({
            message: 'Please select a carrier',
            type: 'error'
          })
          return
        }
        if (!this.carrierData.carrier_account) {
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: 'Account No.' }),
            type: 'error'
          })
          return
        }

        // 调用用户信息修改接口
        const memberData = {
          "req" : {
            "id": JSON.parse(Cookies.get("userinfo")).id,
            "info":{
              carrier: this.carrierData.carrier,
              carrier_account: this.carrierData.carrier_account,
            }
          }
        };
        const memberInfoData = {
          "req" : {
            "id": JSON.parse(Cookies.get("userinfo")).id
          }
        };
        promise1 = editMember(memberData);
        promise2 = getUserInfo(memberInfoData);
      }

      //组装要传到支付页面的数据
      var productidAndNumArr = [];
      let order_type;
      let custom_product_data;
      let info = window.sessionStorage.getItem("settlementInfo");
      if(JSON.parse(info).resource) {
        productidAndNumArr =
            {
              // type_id: JSON.parse(info).typeId,
              type_id: parseInt(JSON.parse(info).type_id),
              number: JSON.parse(info).totalNumber
            }
        ;
        order_type = 2;
        custom_product_data = JSON.parse(info).customForm
      } else {
        for (var i = 0; i < this.shoplist.length; i++) {
          var singlProductandnum = {};
          singlProductandnum.product_id = +this.shoplist[i].product_id;
          singlProductandnum.number = this.shoplist[i].number;
          productidAndNumArr.push(singlProductandnum);
        }
      }

      //组装提交
      const orderParams = {
        req: {
          product_id_numbers: productidAndNumArr,
          address_id: JSON.parse(window.sessionStorage.getItem("settlementInfo")).address_id,
          bill_id: JSON.parse(window.sessionStorage.getItem("settlementInfo")).billing_id,
          bill_type: JSON.parse(window.sessionStorage.getItem("settlementInfo")).bill_type,
          note_message: JSON.parse(window.sessionStorage.getItem("settlementInfo")).note_message,
          order_type: order_type,
          custom_product_data: custom_product_data
        }
      };
      const carrierItem = this.carrierMethod.filter(item => item.value == this.carrierData.carrier);
      if (this.freightIdChooise == 2) {
        orderParams.req.logistics_company = carrierItem[0].name;
        orderParams.req.logistics_account = this.carrierData.carrier_account;
      }
      let promise3 = placeOrder(orderParams);

      Promise.all([promise1, promise2, promise3]).then(res => {
        if (this.freightIdChooise == 2) {
          if (res[1].rsp.code === 0) {
            this.$store.dispatch('setCarNum', true)
            this.$store.dispatch('setUserinfo', res[1].data)
          } else {
            this.$message({
              message: res[1].rsp.msg,
              type: 'error'
            })
          }
        }

        if (res[2].rsp.code === 0) {
          this.$router.push({ path: "/purchase", query: { sn: res[2].data.sn, order_type: order_type} });
          window.sessionStorage.removeItem("settlementInfo");
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success",
          });
        } else {
          this.$message({
            message: res[2].rsp.msg,
            type: "error",
          });
        }
      });
    },
    //到产品界面
    gotoProductDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    handleProductParamsMore(item) {
      let isExit = this.showMore.findIndex(res=>{
        return res == item.id;
      });
      if (isExit > -1) {
        this.showMore.splice(isExit, 1);
      } else {
        this.showMore.push(item.id);
      }
    },
    handleOrderProductMore() {
      this.shopListFloor = this.shopListFloor + 1;
      if (Math.floor((this.shoplist.length-1)/3) === this.shopListFloor) {
        this.shopListFloorComplete = true;
      }
    }
  },
  beforeDestroy() {
    // window.sessionStorage.removeItem("settlementInfo");
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .top {
    .t-l {
      font-size: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #635796;
      line-height: 2.25rem;
    }

    .t-r {
      border-bottom: 2px solid #635796;
      height: 2.125rem;
      line-height: 2rem;

      .t-r-l {
        background: #635796;
        border-radius: 2px;
      }

      .t-r-e {
        padding: 0 1.25rem;
      }

      .tImg {
        width: 1.5rem;
        height: 0.75rem;
        margin: 0 0.75rem;
      }
    }
  }

  .content {
    .c-th {
      height: 3.75rem;
      line-height: 3.75rem;
      background: #f2f2f2;
      border: 1px solid #e6e6e6;
      padding: 0 0.625rem;
    }

    .addr-serach {
      padding: 1.5rem 4.5rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .addr-list {
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
      padding-bottom: 1.5rem;

      .send-to {
        padding: 1.5rem 4.5rem;
      }

      .el-radio-group {
        width: 100%;

        .el-radio {
          word-wrap: break-word;
          word-break: normal;
          white-space: normal;
        }
      }
    }

    .el-radio {
      display: block;
      padding: 0.5rem 4.5rem;
    }

    .el-pagination {
      padding: 1.5rem 4.5rem;
      text-align: center;
    }

    .c-addr {
      padding: 2rem 0.625rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .c-table {
      border: 1px solid #f5f5f5;
      .lh30{
        line-height: 1.5rem;
      }
      .td-label {
        text-align: left;
      }


      .product:nth-child(even) {
        background: #f5f5f5;
      }
      .product {
        margin: 0.5rem 0;
        padding: 0.5rem 1rem;
        // border: 1px solid #f5f5f5;
        background: #fafafa;
      }

      .tr-img {
        height: 4.8rem;
        margin-right: 1.5rem;
      }
    }

    .c-fp {
      padding: 2rem 4.5rem 0;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .c-box {
      padding: 0 1.5rem;
      line-height: 1.75rem;
      border: 1px solid #e6e6e6;
      border-radius: 2px;
      text-align: center;
      cursor: pointer;
      font-size: 12px;
      color: #4d4d4d;
    }

    .c-fp-b {
      margin-top: 2rem;
      padding: 0 1.5rem;
      line-height: 2.75rem;
      background: #fafafa;
    }

    .c-ps {
      padding: 2rem 0.75rem 3rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .c-bz {
      padding: 1rem 30% 1.5rem 1.25rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .c-box + .c-box {
      margin-left: 3.75rem;
    }

    .t-bottom {
      height: 3.75rem;
      line-height: 3.75rem;
      border: 1px solid #e6e6e6;
      background: #f2f2f2;

      .mainBtm {
        width: 10rem;
        height: 3.75rem;
        background: #635796;
        color: #ffffff;
      }
    }
  }

  @media screen and (max-width: 1400px) {
    .top {
      padding: 3.25rem 2%;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .top {
      padding: 3.25rem 10%;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .top {
      padding: 3.25rem 15%;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }

  .mImg {
    width: 0.75rem;
    height: 0.625rem;
  }
}

.bill-info {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  div {
    min-width: 25%;
  }
}

.add-address {
  height: 80px;
  line-height: 80px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
}

.facab {
  flex-wrap: wrap;
}

/deep/ .el-form-item {
  margin-bottom: 0.5rem;
}

/deep/ .el-dialog__header {
  background: #f2f2f2;
  padding: 1rem 1rem 1rem 1.5rem;
  border-radius: 2px;
}
.btn {
  background: #635796;
  border-radius: 4px;
  border-color: #635796;
  color: #ffffff;
}
.btn-close {
  background: #FFF;
  border-radius: 4px;
  border-color: #DCDFE6;
  color: #606266;
}
</style>
